module.exports = function() {
  return new Worker(__webpack_public_path__ + "8aec9fe79d12c44d71d3.worker.js");
};